import React from 'react';
import PropTypes from 'prop-types';

import ProgressBar from 'app/shared/components/Stepper/ProgressBar';

import {
    StyledContainer,
    StyledStepContainer,
} from './StyledComponents';

/*
 * ProgressStepper
 *
 * usage example:
    <ProgressStepper activeIndex={1} isMobile={isMobile}>
        <Step label="Find Listings" mobileLabel="Find" />
        <Step label="Verify to claim" mobileLabel="Verify" />
        <Step label="Convert to ZRM" mobileLabel="Convert" />
    </ProgressStepper>
*/

const propTypes = {
    children: PropTypes.arrayOf(PropTypes.node).isRequired,
    activeIndex: PropTypes.number,
};

const defaultProps = {
    activeIndex: -1,
};

const ProgressStepper = ({ children, activeIndex }) => {
    const childrenArray = React.Children.toArray(children);
    const steps = childrenArray.map((step, index) => {
        const newStep = React.cloneElement(step, {
            ...step.props,
            index,
            activeIndex,
            isActive: step.props.isActive || (index === activeIndex),
            isCompleted: step.props.isCompleted || (index < activeIndex),
        });
        return (
            <StyledStepContainer key={`step-container-${index}`}>
                {index !== 0 && <ProgressBar isActive={index <= activeIndex} />}
                {newStep}
            </StyledStepContainer>
        );
    });
    return (
        <StyledContainer>
            {steps}
        </StyledContainer>
    );
};

ProgressStepper.propTypes = propTypes;
ProgressStepper.defaultProps = defaultProps;

export { ProgressStepper };
export default ProgressStepper;
